<template>
    <table class="chart-legend">
        <tbody>
            <tr
                v-for="(item, index) in data"
                :key="index"
            >
                <td class="legend-label">
                    {{ item.label }}
                </td>
                <td class="legend-indicator">
                    <div
                        class="bar"
                        :style="{
                            '--color': item.color,
                            '--width': `${item.valuePercent}%`,
                        }"
                    />
                </td>
                <td class="legend-percent">
                    {{ item.valueFormatted }}
                </td>
                <td class="legend-value">
                    ({{ numberFormat(item.value) }})
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>

/**
 * External dependencies
 */

/**
 * Internal dependencies
 */
import numberFormat from '@/utils/numberFormat';

export default {
    props: {
        data: {
            required: true,
            type: Array,
        },
    },

    methods: {
        numberFormat,
    },
};
</script>
